import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/dm-sans';
import '@/ui/global.css';
import { AppProviders } from '@/app/providers';
import { hydrateNativeAuth } from '@/lib/native-auth';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root');

// Nativo: hidrata token+perfil de Preferences ANTES de renderizar, pra que a
// primeira chamada /api/auth/me já leve o Bearer e o boot offline tenha identidade.
void hydrateNativeAuth().finally(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <AppProviders />
    </StrictMode>,
  );
});
